import React, { useState, useContext } from "react";
import Header from '../../components/Header';
import TableComponent from '../../components/TableComponent';
import MultiSelectComponent from '../../components/MultiSelectComponent';
import DatePickerComponent from '../../components/DatePickerComponent';
import TextComponent from '../../components/TextComponent';
import TextFieldComponent from '../../components/TextFieldComponent';
import Dashboard from '../../components/Dashboard';
import PageHeaderComponent from '../../components/PageHeaderComponent';
import { CubeJSContext } from '../../context/CubeJSProvider';
import OmnitechQueries from '../../queries/OmnitechQueries'
import { useTranslation } from 'react-i18next';
import { useCubeQuery } from '@cubejs-client/react';
import { format } from 'date-fns'

const applyFilter = (query, storeFilter, paymentProviderCodeFilter) => {
  let storeCodeFilterObj = {
    member: "ShipmentStores.code",
    operator: "equals",
    values: storeFilter
  }

  query = {
    ...query,
    filters: (query.filters || []).concat(storeCodeFilterObj)
  }

  let paymentProviderCodeFilterObj = {
    member: "PaymentProviders.code",
    operator: "contains",
    values: [paymentProviderCodeFilter]
  }
  if(paymentProviderCodeFilter !== ''){
    query = {
      ...query,
      filters: (query.filters || []).concat(paymentProviderCodeFilterObj)
    }
  }

  return query
}

const PaymentByStoreTypeBreakdownQuery = (storeFilter, startDateFilter, endDateFilter, paymentProviderCodeFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  let item = {
    name: t('page.fnb.paymentByStoreTypeBreakdownPage.name'),
    tableHeaders: {
      "Orders.referenceNumber": { name: t('page.fnb.paymentByStoreTypeBreakdownPage.tableHeader.referenceNumber'), type: 'string'},
      "Orders.cartReferenceNumber": { name: t('page.fnb.paymentByStoreTypeBreakdownPage.tableHeader.cartReferenceNumber'), type: 'string'},
      "Orders.completedAt": { name: t('page.fnb.paymentByStoreTypeBreakdownPage.tableHeader.orderCompletedAt'), type: 'dateTime'},
      "PaymentProviders.code": { name: t('page.fnb.paymentByStoreTypeBreakdownPage.tableHeader.code'), type: 'string'},
      "PaymentProviders.internalUseTitle": { name: t('page.fnb.paymentByStoreTypeBreakdownPage.tableHeader.internalUseTitle'), type: 'string'},
      "PaymentRequests.state": { name: t('page.fnb.paymentByStoreTypeBreakdownPage.tableHeader.state'), type: 'string'},
      "PaymentRequests.amount": { name: t('page.fnb.paymentByStoreTypeBreakdownPage.tableHeader.amount'), type: 'number'},
      "PaymentRequests.tip": { name: t('page.fnb.paymentByStoreTypeBreakdownPage.tableHeader.tip'), type: 'number'},
      "PaymentRequests.grandTotal": { name: t('page.fnb.paymentByStoreTypeBreakdownPage.tableHeader.grandTotal'), type: 'number'},
      "PaymentRequests.fullRefundedAt": { name: t('page.fnb.paymentByStoreTypeBreakdownPage.tableHeader.fullRefundedAt'), type: 'dateTime'},
      "PaymentRequests.completedAt": { name: t('page.fnb.paymentByStoreTypeBreakdownPage.tableHeader.paymentCompletedAt'), type: 'dateTime'},
    },
    grid: {xs: 12},
    export: { allowExport: true, filename: 'payment_by_store_and_type_breakdown_export_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orders.PaymentByStoreTypeBreakdown.query,
    "timeDimensions": [
      {
        "dimension": "Orders.completedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, paymentProviderCodeFilter)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const PaymentByStoreTypeBreakdownPage = () => {
  const { t } = useTranslation();
  const context = useContext(CubeJSContext);
  let storeCodeSelect = []
  if(context.storeCodes)
    storeCodeSelect = context.storeCodes
  const [ storeFilter, setStoreFilter ] = useState([]);
  let filterStartDate = new Date()
  filterStartDate.setHours(0,0,0,0);
  let filterEndDate = new Date()
  filterEndDate.setHours(23,59,59,999);
  const [dateRangeFilter, setDateRangeFilter] = useState([filterStartDate, filterEndDate])
  const [startDateFilter, endDateFilter] = dateRangeFilter
  const [ paymentProviderCodeFilter, setPaymentProviderCodeFilter ] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [ refresh1, setRefresh1 ] = useState(false);

  const { item, result }  = PaymentByStoreTypeBreakdownQuery(storeFilter, startDateFilter, endDateFilter, paymentProviderCodeFilter, refresh1, setRefresh1)

  const refresh = () => {
    setRefresh1(true)
    setPage(0)
  }

  return ([
    <Header />,
    <PageHeaderComponent onClickFunc={refresh} refreshlabel={t('component.refresh')} headerTitle={t('component.header.menu.paymentByStoreTypeBreakdown')} />,
    <Dashboard>
      <MultiSelectComponent id={"store_code_filter"} state={storeFilter} pageChangerArr={[setPage]}
          stateChanger={setStoreFilter} textLabel={t('page.fnb.paymentByStoreTypeBreakdownPage.filter.store.name')} selectArray={storeCodeSelect}/>
      <DatePickerComponent state={dateRangeFilter} stateChanger={setDateRangeFilter} dateLabel={t('page.fnb.paymentByStoreTypeBreakdownPage.filter.orderCompletedAt.date')}/>
      <TextFieldComponent id={"payment_provider_code_filter"} state={paymentProviderCodeFilter} pageChangerArr={[setPage]} 
        stateChanger={setPaymentProviderCodeFilter} textLabel={t('page.fnb.paymentByStoreTypeBreakdownPage.filter.paymentProviderCode')}/>
    </Dashboard>,
    <Dashboard>
      <TextComponent title={t('component.text.paymentBreakdownMapping')} 
        contentArray={[t('page.fnb.paymentByStoreTypeBreakdownPage.paymentCodeMapping.vsm'),
        t('page.fnb.paymentByStoreTypeBreakdownPage.paymentCodeMapping.msm'),
        t('page.fnb.paymentByStoreTypeBreakdownPage.paymentCodeMapping.CV'),
        t('page.fnb.paymentByStoreTypeBreakdownPage.paymentCodeMapping.CU'),
        t('page.fnb.paymentByStoreTypeBreakdownPage.paymentCodeMapping.aem'),
        t('page.fnb.paymentByStoreTypeBreakdownPage.paymentCodeMapping.CASH_HKD'),
        t('page.fnb.paymentByStoreTypeBreakdownPage.paymentCodeMapping.octopus'),
        t('page.fnb.paymentByStoreTypeBreakdownPage.paymentCodeMapping.alipay_hkd_manual'),
        t('page.fnb.paymentByStoreTypeBreakdownPage.paymentCodeMapping.wechat_pay_hkd_manual')]} xs={12} />
      <TableComponent item={item} result={result} rowsPerPage={rowsPerPage} 
        setRowsPerPage={setRowsPerPage} page={page} setPage={setPage}/>
    </Dashboard>
  ]) 
};

export default PaymentByStoreTypeBreakdownPage;